import { identify, makeRequest, Service } from '../../../utils/http';

type Data = {
  orderId: string;
};

export async function approveOrderApi({ orderId }: Data) {
  return makeRequest(Service.approveOrder(orderId, await identify()));
}
